<template>
  <div class="environment-state today-alarm">
    <nk-box-title :icon-class="'iconfont icon-huanjingzhuangtai1'" :title="'环境状态'">
      <!-- <div slot="title" class="logo"> -->
      <div slot="title" >
          <!-- 插槽的内容 -->
      </div>
      <div class="content dn-content-bg" >
        <div class="param-left">
          <div class="ico-box qh"><i class="iconfont icon-wendu" ></i></div>
        </div>
        <div class="param-right">
            <div class="top">
                <div class="title zt">室外实时温度:<span class="time">{{envirState.wd}}</span><span style="color: #e9ae26;">℃</span></div>
            </div>
            <div class="bottom">
                <div class="title zt">室外实时湿度:<span class="time">{{envirState.sd}}</span><span style="color: #e9ae26;">%</span></div>
            </div>
          
        </div>
      </div>
    </nk-box-title>
  </div>
</template>
<script>
import NkBoxTitle from "@/components/common/NkBoxTitle.vue";
export default {
  components: { NkBoxTitle },
  data() {
    return {
        envirState:{},
        time:60,
        interTime:null
    };
  },
  created() {
      this.getData()
  },
  mounted() {
      this.temperature=this.envirState.temperature
      this.humidity=this.envirState.humidity
  },
  methods: {
      getData(){
            let vm = this
            vm.$api.tmp.getWSD().then(res=>{
                if(res.success){
                    res.data.sd=res.data.sd==''?'-':res.data.sd
                    res.data.wd=res.data.wd==''?'-':res.data.wd
                    vm.envirState= res.data
                    if(vm.interTime){
                        clearTimeout(vm.interTime);
                    }
                    if(vm.time > 0){
                        vm.interTime = setTimeout(() => {
                            vm.getData()
                        }, vm.time * 1000);
                    }
                }else{
                    vm.envirState.wd='-'
                    vm.envirState.sd='-'
                    vm.$message.error(res.msg)
                    
                }
            }).catch(error=>{
                // vm.$messge.error(error.msg)
            })
        }
  },
};
</script>
<style lang="scss" scoped>
.spanColor{
    color: rgba(242, 178, 54);
}
.environment-state {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column;
  .logo {
    line-height: 25px;
    display: flex;
    flex-flow: row;
    color: rgba(30, 30, 30);
    margin-left: 5px;
    .logoImg {
      margin-right: 5px;
    }
  }
  .content {
    display: flex;
    flex: 1;
    flex-flow: row;
    color: #181818;
    .param-left {
        display: flex;
        flex: 2;
        justify-content: center;
        align-items: center;
        .ico-box{
            width: 80px;
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            i{
                font-size: 48px;
                color: rgba(59, 173, 238)
            }
        }
    }
    .param-right {
        display: flex;
        flex: 3;
        flex-flow: column;
      .top {
            display: flex;
            flex: 1;
            justify-content: left;
            align-items: center;
            .title{
                .time{
                    font-size: 29px;
                    margin-left: 5px;
                    font-weight: 600;
                    margin-right: 4px;
                    color: #e9ae26;
                }
            }
        }
        .bottom{
            display: flex;
            flex: 1;
            justify-content: left;
            // align-items: center;
            .title{
                .time{
                    font-size: 29px;
                    margin-left: 5px;
                    font-weight: 600;
                    margin-right: 4px;
                    color: #e9ae26;
                }
            }
        }
    }
  }
}
</style>